import * as React from "react";
import * as $ from "jquery";

import ConnectedPeopleComp from "./ConnectedPeopleComp";
import ToggleBtn from "../lib/components/ToggleBtn";
import {Select, ISelectItem} from "../lib/components/Select";
import { ComboBox, IComboBoxValues } from "../lib/components/ComboBox";
import Modal from "../lib/components/Modal";

import {IUser, IProileComp, IUserWithDefaultConnection, IEditItemCompProps, IConnnectedPeople, IEditItemCompState} from "../../interfaces/layout/blocks/IUser";
import { ReInitEditItemCompImage } from "./EditItemCompImage";

declare var window:any;
export class EditItemCompCore extends React.Component<IEditItemCompProps, IEditItemCompState>{
    protected id:number;
    protected currentId:number;

    constructor(props: IEditItemCompProps) {
        super(props);
        this.id = 0;
        this.currentId = 0;
        // set initial state4
        this.state = this.getInitState();

        if ( this.props.id > 0 ) {
            this.id = this.props.id;
            this.currentId = this.props.id;
			this.getData(this.id);
		}else{
            // tslint:disable-next-line:no-unused-expression
            new ReInitEditItemCompImage(this.id, '');
        }
    }

    componentDidMount() {
    }

    protected getInitState():any {
        window.temp = {};
		var json:any =  {
            data:{
                type: '',
                sex: 'male',
                lastName: '',
                firstName: '',
                email: '',
                password: '',
                birthName: '',
                birthPlaceCountry: '',
                birthPlaceCountryLat: '',
                birthPlaceCountryLng: '',
                birthPlaceCity: '',
                birthPlaceCityLat: '',
                birthPlaceCityLng: '',
                birthDate: '',
                city: '',
                deathDate: '',
                img: ''
            },
            ProfileFormFieldsData:{
                itemPlaces: [
                    {
            			fromDate: '',
            			toDate: '',
            			city: ''
            		}
                ],
                itemSchools: [
                    {
            			fromDate: '',
            			toDate: '',
            			city: '',
            			school: '',
            			education: ''
            		}
                ],
                itemJobs: [
                    {
            			fromDate: '',
            			toDate: '',
            			city: '',
            			job: '',
            			jobTitle: ''
            		}
                ],
                itemHonors: [
                    {
                        date: '',
            			name: ''
            		}
                ],
                itemArmy: [
                    {
                        fromDate: '',
            			toDate: '',
            			city: '',
            			unit: '',
            			level: ''
            		}
                ],
                itemLanguages: [
                    {
            			name: ''
            		}
                ],
                itemHobbies: [
                    {
            			name: ''
            		}
                ],
                nameDayMonth: null,
                nameDayDay: null,
                note: '',
                religion: null
            },
            motherId: 0,
            fatherId: 0,
            motherName: null,
            fatherName: null,
            childrensIds: [],
            couplesIds: [],
            passwordm : '',
            connnectedPeople: {
                couples: [],
                childrens: []
            },
            success: [],
            errors: [],
            otherParent: {
                currentValue : '',
                currentLabel : '',
                source: []
            },
			showDeathbox: false,
			allUser: {
				source: []
			},
			showProfielFromField: false
        };
        return json;
    }

    protected save(): void {
        var saveData:any = this.state.data;
		if ( this.id > 0 ) {
			saveData.id = this.id;
		}
		saveData.currentId = this.currentId;

        if ( saveData.id !== 0 && this.state.otherParent.currentLabel !== '' && this.state.otherParent.currentValue !== '' ) {
            saveData.otherParentId = parseInt(this.state.otherParent.currentValue);
            saveData.otherParentName = this.state.otherParent.currentLabel;
			saveData.otherParentSex = 'male';
			if ( this.state.motherId === null ) {
				saveData.otherParentSex = 'female';
			}
        }
        saveData.imageSource = this.getImgSource();
        saveData.originalFile = window.temp.originalFile;
        saveData.smallFile = window.temp.smallFile;
        if ( window.editItemImage !== undefined ) {
		    saveData.removeImage = window.editItemImage.removeImage;
            if ( window.editItemImage.image !== undefined ) {
                saveData.img = window.editItemImage.image;
            }
            if ( saveData.removeImage === true ) {
                saveData.img = '';
            }
        }
        saveData.ProfileFormFieldsData = this.state.ProfileFormFieldsData;
        $.ajax({
            data: saveData,
            type: "POST",
            url:  '/saveUser',
            contentType: "application/x-www-form-urlencoded;charset=UTF-8",
            success: (data) => {
                if (data.success !== undefined
                    && data.success === true &&  this.currentId === 0) {
					 window.location.href = '/csaladtagok';
                } else if (data.error !== undefined) {
                    this.setState({
                        errors: [data.error],
                        success: []
                    } as IEditItemCompState);
                }else if( data.id !== undefined && data.id > 0 ){
                    this.getData(data.id, [ 'Sikeres módosítás!' ], []);
                }else if( data.insertedId !== undefined && data.insertedId > 0 ){
                    this.id = data.insertedId;
                    this.currentId = data.insertedId;
                    this.getData(data.insertedId, [ 'Sikeres mentés!' ], []);
                }
            }
        });
    }

	protected getData(id:number, success?:Array<string>, error?:Array<string>){
		$.ajax({
			data: {
				id: id
			},
			type: "POST",
			url:  '/getUser',
			contentType: "application/x-www-form-urlencoded;charset=UTF-8",
			success: (data) => {
				if (data.data !== undefined ) {
                    var source:IUserWithDefaultConnection = data.data;
                    this.id = id;
                    this.currentId = id;
                    var newState = {
						data: {
                            type: source.type,
                            sex: source.sex,
                            lastName: source.lastName,
                            firstName: source.firstName,
                            email: source.email,
                            password: source.password,
                            birthName: source.birthName,
                            birthPlaceCountry: source.birthPlaceCountry,
                            birthPlaceCountryLat: source.birthPlaceCountryLat,
                            birthPlaceCountryLng: source.birthPlaceCountryLng,
                            birthPlaceCity: source.birthPlaceCity,
                            birthPlaceCityLat: source.birthPlaceCityLat,
                            birthPlaceCityLng: source.birthPlaceCityLng,
                            birthDate: source.birthDate,
                            deathDate: source.deathDate,
                            city: source.city,
                            img: source.img !== null?source.img.replace('.jpg', '_medium.jpg'): null
                        },
                        motherId: source.motherId,
                        motherName: source.motherName,
                        fatherId: source.fatherId,
                        fatherName: source.fatherName,
                        childrensIds: source.childrensIds,
                        couplesIds: source.couplesIds,
                        passwordm : '',
                        connnectedPeople: data.connnectedPeople,
                        otherParent: {
                            currentValue : '',
                            currentLabel : '',
                            source: []
                        },
                        showDeathbox: source.deathDate !== '' ? true : false,
                        ProfileFormFieldsData:{
                            itemPlaces: [
                                {
                        			fromDate: '',
                        			toDate: '',
                        			city: ''
                        		}
                            ],
                            itemSchools: [
                                {
                        			fromDate: '',
                        			toDate: '',
                        			city: '',
                        			school: '',
                        			education: ''
                        		}
                            ],
                            itemJobs: [
                                {
                        			fromDate: '',
                        			toDate: '',
                        			city: '',
                        			job: '',
                        			jobTitle: ''
                        		}
                            ],
                            itemHonors: [
                                {
                                    date: '',
                        			name: ''
                        		}
                            ],
                            itemArmy: [
                                {
                                    fromDate: '',
                        			toDate: '',
                        			city: '',
                        			unit: '',
                        			level: ''
                        		}
                            ],
                            itemLanguages: [
                                {
                        			name: ''
                        		}
                            ],
                            itemHobbies: [
                                {
                        			name: ''
                        		}
                            ],
                            nameDayMonth: null,
                            nameDayDay: null,
                            note: '',
                            religion: null
                        }
					} as IEditItemCompState;
                    if (data.ProfileFormFieldsData !== null ) {
                        for (var key in data.ProfileFormFieldsData) {
                            var item = data.ProfileFormFieldsData[key];
                            if ( $.isArray(item) ) {
                                if (item.length !== 0) {
                                    newState.ProfileFormFieldsData[key] = item;
                                }else{
                                    if ( this.props.profileMode === true && document.querySelector('.view_mode') !== null ) {
                                        newState.ProfileFormFieldsData[key] = [];
                                    }
                                }
                            }else{
                                newState.ProfileFormFieldsData[key] = item;
                            }
                        }
                    }
                    if ( success !== undefined ) {
                        newState.success = success;
                    }
                    if ( error !== undefined && error !== null ) {
                        newState.errors = error;
                    }
					this.setState(newState);
                    // tslint:disable-next-line:no-unused-expression
                    new ReInitEditItemCompImage(this.id, newState.data.img);
                    if ( this.showOtherParentCombobox() ) {
                        // NOTE: ha többneylvü lesz akkor a lastnaem kell
                        this.getOtherParentSource();
                    }
				} else if (data.error !== undefined) {
					this.setState({
						errors: [data.error]
					} as IEditItemCompState);
				}
			}
		});
	}

    protected checkValid(): boolean {
        var err: Array<string> = [];
        var data:IUser = this.state.data;


        if (data.firstName === '') {
            err.push('Kérem, adja meg a vezetéknevét!');
        }

        if (data.lastName === '') {
            err.push('Kérem, adja meg a keresztnevét!');
        }
        if ( this.props.registrationMode === true ) {
            if (data.email === '') {
                err.push('Kérem, adja meg az e-mail címét!');
            } else {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(data.email) === false) {
                    err.push('Hibás e-mail cím!');
                }
            }
            if (data.password === '') {
                err.push('Kérem, adja meg a jelszavát!');
            }
            if (this.state.passwordm === '') {
                err.push('Kérem, adja meg a jelszavát mégegyszer!');
            }
            if (this.state.passwordm !== data.password) {
                err.push('A két jelszó nem egyezik!');
            }
            if (data.birthName === '') {
                err.push('Kérem, adja meg a születési nevét!');
            }
            if (data.birthPlaceCountry === '') {
                err.push('Kérem, adja meg a születési helyét(ország)!');
            }
            if (data.birthPlaceCity === '') {
                err.push('Kérem, adja meg a születési helyét(város)!');
            }
            if (data.birthDate === '') {
                err.push('Kérem, adja meg a születési dátumát!');
            }
        }


        this.setState({
            errors: err
        } as IEditItemCompState);
        return err.length === 0;
    }

    protected changeType(type:string): void {
        var oldId:number = this.id;
        this.id = 0;
        var sex:string = 'male';
        switch( type ){
            case 'father':
                // check update
                if ( this.state.fatherId !== null && this.state.fatherId > 0 ) {
                    this.id = this.state.fatherId;
                    this.currentId = oldId;
                }
            break;
            case 'mother':
                // check update
                if ( this.state.motherId !== null && this.state.motherId > 0 ) {
                    this.id = this.state.motherId;
                    this.currentId = oldId;
                }
                sex = 'female';
            break;
            case 'couple':
                sex = 'male';
                if ( this.state.data.sex === 'male') {
                    sex = 'female';
                }
                this.currentId = oldId;
            break;
            case 'children':
                this.currentId = oldId;
            break;
        }
		if ( this.id > 0 ) {
			this.getData(this.id);
		}else{
			var state = this.getInitState();
			state.data.type = type;
			state.data.sex = sex;
		}
        this.setState(state);
    }

    protected getOtherParentSource():void{
        var parentId:number = 0;
        if ( this.id !== 0 ) {
            if ( this.state.fatherId !== null ) {
                parentId = this.state.fatherId;
            }else{
                parentId = this.state.motherId;
            }
        }else{
            parentId = this.currentId;
        }
        $.ajax({
              data:{
                  'id'                  : this.id,
                  'creatorId'           : parentId,
                  'firstname'           : this.state.data.firstName
              },
              type:               "POST",
              url:                 '/user/getOtherParents',
              contentType:        "application/x-www-form-urlencoded;charset=UTF-8",
              success: (data) => {
                 if ( data.items !== undefined ) {
                    var curr = this.state.otherParent;
                    curr.source = data.items;
                    this.setState({
                        otherParent: curr
                    } as IEditItemCompState);
                }
              }
       });
    }

	protected showOtherParentCombobox():boolean{
        if ( this.id === 0 ) {
            return false;
        }
		if ( this.state.data.type === 'children'
			|| (this.state.data.type === '' && this.state.fatherId === null && this.state.motherId !== null)
			|| (this.state.data.type === '' && this.state.motherId === null && this.state.fatherId !== null)
		) {
			return true;
		}
		return false;
	}

    protected getMonth(selectedId:number, placeholder:string):Array<ISelectItem>{
        var ret:Array<ISelectItem> = [{
            name: placeholder,
            id: 0,
            selected: false
        }];
        for (let i = 1; i < 13; i++) {
            ret.push({
                name: i.toString(),
                id: i,
                selected: selectedId===i ? true : false
            });
        }
        return ret;
    }

    protected getDays(selectedId:number, placeholder:string):Array<ISelectItem>{
        var ret:Array<ISelectItem> = [{
            name: placeholder,
            id: 0,
            selected: false
        }];
        for (let i = 1; i < 32; i++) {
            ret.push({
                name: i.toString(),
                id: i,
                selected: selectedId===i ? true : false
            });
        }
        return ret;
    }

    protected getImgSource():string{
        var canvas:HTMLCanvasElement = document.getElementById('image_editor') as HTMLCanvasElement;
		if ( this.isCanvasBlank(canvas) ) {
			return '';
		}else{
			return canvas.toDataURL("image/jpeg");
		}
    }

	protected isCanvasBlank(canvas):boolean {
        if ( document.createElement('canvas') === null || canvas === null ) {
            return true;
        }
	    var blank = document.createElement('canvas');
	    blank.width = canvas.width;
	    blank.height = canvas.height;
	    return canvas.toDataURL() === blank.toDataURL();
	}

}



// WEBPACK FOOTER //
// ./components/EditItemCompCore.tsx